import * as React from 'react';
import { Link } from 'react-router-dom';

import { QuestionList } from '../questionList';
import { hashToCollection } from '../../libs';

export interface TitleCardsProps {
  titleCards: any;
}

const TitleCards = ({ titleCards,}) => {
  const renderQuestionsList = () => {
    const { data, hasreceiveddata } = titleCards;

    const formattedTitleCards = hashToCollection(data);
    if (hasreceiveddata && formattedTitleCards) {
      return <QuestionList basePath='title-cards' questions={formattedTitleCards || []} />
    } else if (!hasreceiveddata) {
      return <p>Loading...</p>
    } else {
      return <p>No title cards yet</p>
    }
  }

  return (
    <section className="section">
      <div className='admin-container'>
        <Link className="button is-primary" to="/admin/title-cards/new">Create a New Title Card</Link>
        <p className="menu-label">Title Cards</p>
        {renderQuestionsList()}
      </div>
    </section>
  )
}

export { TitleCards, }
